import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Container, Col } from "react-bootstrap";
import { Heading, TableRowWithIcon, RowsWrapper, CollapsibleContent, ExpandableContent, BfButtonBlue } from '../../../Styling/styledForm/styledBlueForm'
import { ScoreGroupContainer, ScorePairContainer, ScoreTitle, ScoreValue, DownloadAndScoreRow, StyledKredittvurderingTable } from '../../../Styling/styledKredittvurdering/styledKvComponents'
import { StyledKfTable } from '../../../Styling/styledTable/StyledTable';
import styled from 'styled-components';
import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../components/useTable/UsePaginator';
import { FormattedDate } from 'react-intl'
import CaseListToolTip from '../../caselist_redux/caseListTable/CaseListTooltip';
import privatPdfV2 from '../pdfs/privatPdfV2';
import privatPdfV3 from '../pdfs/privatPdfV3';
import privatPdfV4 from '../pdfs/privatPDFV4';
import næringPdfV2 from '../pdfs/næringPdfV2';
import næringPdfV3 from '../pdfs/næringPdfV3';
import næringPdfV4 from '../pdfs/næringPdfV4';
import { useSelector } from 'react-redux'
import { CollapsibleButton, KredittvurderingRowForm } from '../../../Styling/styledKredittvurdering/styledKvComponents';
import { RatingCircle } from '../../../components/ratingCircle/RatingCircle';
import IframeModal from '../../../components/iframeModal/IframeModal';

const Circle = styled.button`    
    background: ${props => props.primary || "white"};
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid black;
    margin: 0;
`;

const ExpandableRow = ({ isExpanded, children }) => {
    const contentRef = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (contentRef.current) {
            const contentHeight = contentRef.current.scrollHeight;
            setHeight(isExpanded ? contentHeight : 0);
        }
    }, [isExpanded]);

    return (
        <ExpandableContent ref={contentRef} $isexpanded={isExpanded} height={height}>
            {children}
        </ExpandableContent>
    );
};

const KredittvurderingSearchHistory = (props) => {

    const localeMessages = props.localeMessages
    const crState = useSelector(state => state.sakslisteHeader)
    const headerState = useSelector(state => state.sakslisteHeader)
    const searchHistoryData = useMemo(() => {
        return props.searchHistoryData !== undefined ? props.searchHistoryData : [];
    }, [props.searchHistoryData]);  

    // // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('down'); // default
    const [currentField, setCurrentField] = useState('transactionDate');    // feltnavn
    // Sett typen til string selvom default er datetime, ellers virker ikke sorteringen
    const [currentType, setCurrentType] = useState('string'); // num
    // eslint-disable-next-line no-unused-vars
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    const [pdfUrl, setPdfUrl] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType);

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);

    const [isCollapsed, setIsCollapsed] = useState(true);

    const saveCollapsedValue = (value) => {
        localStorage.setItem("KVSearchHistory", JSON.stringify(value));
    }

    // Listen er utvidet eller minimert basert på hva den var sist. 
    useEffect(() => {
        const savedValue = JSON.parse(localStorage.getItem("KVSearchHistory")) ?? true;
        setIsCollapsed(savedValue);
    }, []);

    const toggleCollapse = () => {
        setIsCollapsed((prevState) => {
            const newValue = !prevState;
            saveCollapsedValue(newValue);
            return newValue;
        });
    };

    const [expandedRow, setExpandedRow] = useState(null);

    const handleRowClick = (rowIndex) => {
        setExpandedRow((prevRow) => (prevRow === rowIndex ? null : rowIndex));
    };

    const contentRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(0);
    
    // Setter høyden for table
    useEffect(() => {
        if (contentRef.current) {
          if (isCollapsed) {
            setContentHeight(0);
          } else {
            // Høyden for table
            const normalHeight = contentRef.current.scrollHeight;
            // Utvider om rad er expanded
            const expandedHeight = expandedRow ? normalHeight + 700 : normalHeight;
            setContentHeight(expandedHeight);
          }
        }
      }, [isCollapsed, expandedRow, numberPrPage, searchHistoryData]);
        
    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex] = usePaginator(
        searchHistoryData.sort(t1GetSortFunc().fn),
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )

    const formatDebtorIdNr = (numStr) => {
        if (numStr.length === 9) {
            return numStr.slice(0, 3) + " " + numStr.slice(3, 6) + " " + numStr.slice(6);
        } else if (numStr.length === 11) {
            return numStr.slice(0, 6) + " " + numStr.slice(6);
        } else {
            return '';
        }
    };

    const parseDateString = (inputDate) => {
        const cleanedDate = inputDate.replace(/\[.*\]$/, '');
        return new Date(cleanedDate);
    };

    const handleExport = async (data, debtorType, kredittvurderingDate, user, debtorIdNumber,       newVersion, localeMessages) => {
        if (data === null || data === undefined) return;

        let currentKreditor = headerState.kreditorliste.find(e => e.customerNo === headerState.kreditorId)
        const date = parseDateString(kredittvurderingDate)
        if (debtorType === 'Privat' && newVersion === "2.0") {
            return await privatPdfV2(data, user, date, currentKreditor.disp, formatDebtorIdNr(debtorIdNumber), localeMessages);
        } else if (debtorType === 'Privat' && newVersion === "3.0") {
            return await privatPdfV3(data, user, date, currentKreditor.disp, formatDebtorIdNr(debtorIdNumber), localeMessages);
        } else if (debtorType === 'Privat' && newVersion === "4.0") {
            return await privatPdfV4(data, user, date, currentKreditor.disp, formatDebtorIdNr(debtorIdNumber), localeMessages, true);
        } else if (debtorType === 'Næring' && newVersion === "2.0") {
            return await næringPdfV2(data, user, date, currentKreditor.disp, formatDebtorIdNr(debtorIdNumber), localeMessages);
        } else if (debtorType === 'Næring' && newVersion === "3.0") {
            return await næringPdfV3(data, user, date, currentKreditor.disp, formatDebtorIdNr(debtorIdNumber), localeMessages);
        } else if (debtorType === 'Næring' && newVersion === "4.0") {
            return await næringPdfV4(data, user, date, currentKreditor.disp, formatDebtorIdNr(debtorIdNumber), localeMessages, true);
        }
    };
    

    function formatNumberWithSpaces(input) {
        const str = String(input).trim();
        const [intPart, decPart] = str.split('.');
        const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return decPart != null ? `${formattedInt}.${decPart}` : formattedInt;
    }

          
    const BigValueGroup = ({ pairs, style }) => {
        return (
            <ScoreGroupContainer customStyle={style}>
            {pairs.map((pair, index) => (
                <ScorePairContainer key={index}>
                    <ScoreTitle style={{fontSize: '16px'}}>{pair.title}</ScoreTitle>
                    <ScoreValue style={{fontSize: '20px'}}>{pair.value}</ScoreValue>
                </ScorePairContainer>
            ))}
            </ScoreGroupContainer>
        );
    };
    
    // Versjon 2.0 og 3.0 brukte norske navn
    const bigValuePairs = (model) => [
        { title: 'Score', value: model.score },
        { title: 'Karakter', value: model.scoreKarakter },
        { title: 'Rating', value: <RatingCircle value={model.score} /> },
        { title: 'Vurdering', value: model.scoreForklaring },
        { title: 'Anbefalt kredittgrense', value: formatNumberWithSpaces(model.kredittgrense) },
    ];

    // Versjon bruker engelske navn
    const bigValuePairsV4 = (model) => [
        { title: 'Score', value: model.risk.normalisedScore },
        { title: 'Karakter', value: model.risk.scoreRating },
        // { title: 'Rating', value: <RatingCircle value={model.risk.normalisedScore} /> },
        { title: 'Vurdering', value: model.risk.scoreRatingExplanation },
        { title: 'Anbefalt kredittgrense', value: formatNumberWithSpaces(model.risk.creditLimit) },
    ];

    const handlePreview = async (ratingData, debtorType, transactionDate, emailUser, searchTerm, newVersion, localeMessages) => {
      if (!ratingData || !debtorType) return;
      try {
        const blob = await handleExport(
            ratingData,
            debtorType,
            transactionDate,
            emailUser,
            searchTerm,
            newVersion,
            localeMessages,
        );
        const url  = URL.createObjectURL(blob)
        setPdfUrl(url)
        setModalOpen(true)
      } catch (err) {
        console.error('PDF preview failed', err)
      } finally {
      }
    }

    const RatingInformation = (model, version) => {
        if (version === '4.0') {
            return (
                <RowsWrapper style={{flexDirection: 'column', padding: '0 0 40px 10px' }}>
                    <DownloadAndScoreRow>
                        <BigValueGroup pairs={bigValuePairsV4(model)} />
                    </DownloadAndScoreRow>
                    <div>
                        <p style={{fontWeight: 'bold', paddingTop: '20px' }}>{localeMessages.considerDownloading}</p>
                    </div>
                </RowsWrapper>
            )
        } else {
            return (
             <RowsWrapper style={{flexDirection: 'column', padding: '0 0 40px 10px' }}>
                    <DownloadAndScoreRow>
                        <BigValueGroup pairs={bigValuePairs(model)} />
                    </DownloadAndScoreRow>
                    <div>
                        <p style={{fontWeight: 'bold', paddingTop: '20px' }}>{localeMessages.considerDownloading}</p>
                    </div>
                </RowsWrapper>
            )
        }
    }

    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
        return (
            <thead>
                <tr>
                    <th style={{ backgroundColor: 'white' }}></th>
                    <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('transactionDate', 'string')}>{localeMessages['SH_Date']}{t1IndicaterIcon('transactionDate')}</th>
                    <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('emailUser', 'string')}>{localeMessages['SH_by']}{t1IndicaterIcon('emailUser')}</th>
                    <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('action', 'string')}>{localeMessages['SH_activity']}{t1IndicaterIcon('action')}</th>
                    <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('searchType', 'string')}>{localeMessages['SH_Type']}{t1IndicaterIcon('searchType')}</th>
                    <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('name', 'string')}>{localeMessages['SH_Name']}{t1IndicaterIcon('name')}</th>
                    <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('searchTerm', 'num')}>{localeMessages['SH_PersonOrg']}{t1IndicaterIcon('searchTerm')}</th>
                    <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('newVersion', 'num')}>{localeMessages['SH_Version']}{t1IndicaterIcon('newVersion')}</th>
                    <th style={{ backgroundColor: 'white' }}></th>
                </tr>
            </thead>
        )
    }

    function getModelName(model) {
        const type = model.searchType;
        if (type === 'Næring') {
            return model.bislabJson?.organisationInformation?.organisationName || '-';
        }
        if (type === 'Privat') {
            return model.bislabJson?.personInformation?.name || '-';
        }
        return '-';
    }

    const printRow = (model) => {
        const asDate = (val) => {
            const dateStringWithoutUTC = val.replace('[UTC]', '');

            if (dateStringWithoutUTC === null || dateStringWithoutUTC === '' || dateStringWithoutUTC === undefined) {return (<>{''}</>)};
            return (
                <FormattedDate value={dateStringWithoutUTC} day="2-digit" month="2-digit" year="numeric" />
            )
        }
        
        return (
            <>
            <TableRowWithIcon key={model.j.toString()} style={{ cursor: 'pointer' }} onClick={() => handleRowClick(model.j)} isCollapsed={expandedRow !== model.j}>
                <td>
                    <span className="icon arrow"></span>
                </td>
                <td>{asDate(model.transactionDate)}</td>
                <td>{model.emailUser}</td>
                <td>Kredittsjekk</td>
                <td>{model.searchType}</td>
                <td>{getModelName(model)}</td>
                <td>{model.searchTerm}</td>
                <td>{model.newVersion}</td>
                {/* Wrapper i en div for å unngå at rad utvider/kollapser når bruker trykker på pdf-knapp */}
                <div onClick={(e) => { 
                    e.stopPropagation(); 
                    handlePreview(
                        model.bislabJson !== undefined ? model.bislabJson : null,
                        model.searchType,
                        model.transactionDate,
                        model.emailUser,
                        model.searchTerm,
                        model.newVersion,
                        localeMessages,
                    );
                }}>
                    <CaseListToolTip caption={'Last ned resultat (PDF)'}>
                        <span style={{ marginTop: '15px' }} className="fa fa-download" />
                    </CaseListToolTip>
                </div>
            </TableRowWithIcon>
            {expandedRow === model.j && (
            <>
                <tr key={model.i + 1000} onClick={() => handleRowClick(model.j)} >
                    <td colSpan="9" >
                        <ExpandableRow key={model.i + 10000} isExpanded={expandedRow === model.j}>
                            { RatingInformation(model.bislabJson, model.newVersion) }
                        </ExpandableRow>
                    </td>
                </tr>
            </>)}
            </>
        )
    }

    return (
        <>
            {modalOpen && pdfUrl && (
                <IframeModal
                    src={pdfUrl}
                    downloadName={`Kredittvurdering.pdf`}
                    onClose={() => setModalOpen(false)}
                />
            )}
            <Container fluid="true">
                <KredittvurderingRowForm>
                    <Col xs={12} md={12}>
                        <div style={{ display: 'flex' }}>
                            <Heading style={{ flex: '1' }}>{localeMessages.SH_Title}</Heading>
                            <div style={{ flex: '1' }}>
                                <CollapsibleButton
                                    isCollapsed={isCollapsed}
                                    onClick={toggleCollapse}
                                >
                                    <span className="icon arrow"></span>
                                    <span className="button-text">{isCollapsed ? 'Utvid' : 'Minimer'}</span>
                                </CollapsibleButton>
                            </div>
                        </div>
                        <CollapsibleContent ref={contentRef} height={contentHeight}>
                            <PaginationDropdown />
                            <StyledKredittvurderingTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}
                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKredittvurderingTable>
                            <br />
                            <PaginationIndex />
                            <br /><br />
                            <div style={{display: 'flex'}}>
                                <PaginationNav />
                                &nbsp;&nbsp;   &nbsp;&nbsp;
                                <CaseListToolTip caption={localeMessages.updateList_text}>
                                    <BfButtonBlue style={{height: '45px'}} variant="primary" type="button" onClick={() => props.getRatingInfo()} >
                                        {localeMessages.updateListButton}
                                    </BfButtonBlue>
                                </CaseListToolTip>
                            </div>
                            <br />
                        </CollapsibleContent>
                        {isCollapsed && <br />}
                    </Col>
                </KredittvurderingRowForm>
            </Container>
        </>
    );
}

export default React.memo(KredittvurderingSearchHistory)



